var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoContentPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 235,
    viewBox: "0 0 307 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4747_22018)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M239.263 193.874C239.263 193.874 235.808 186.463 240.352 183.762C244.896 181.06 252.064 185.957 250.252 189.722C249.65 190.832 248.801 191.787 247.771 192.514C246.741 193.241 245.557 193.72 244.312 193.913L239.263 193.874Z",
    fill: "#FF6D34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.9 98.4258C206.9 98.4258 223.73 124.332 206.9 174.803",
    stroke: "#24285B",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.218 114.061C98.218 114.061 77.9923 137.901 86.5855 149.821C95.1787 161.741 116.741 151.41 123.78 128.335",
    stroke: "#24285B",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8128 108.26C91.8128 108.26 83.4176 109.601 84.368 115.948C85.3184 122.296 95.1491 130.51 102.01 127.868C108.87 125.226 105.297 114.061 105.297 114.061L91.8128 108.26Z",
    fill: "#FFBD59"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M91.8128 108.26C91.8128 108.26 83.4176 109.601 84.368 115.948C85.3184 122.296 95.1491 130.51 102.01 127.868C108.87 125.226 105.297 114.061 105.297 114.061L91.8128 108.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.285 56.0593C126.286 54.7375 126.027 53.4284 125.524 52.207C125.02 50.9856 124.282 49.8758 123.35 48.9412C122.419 48.0065 121.313 47.2654 120.095 46.7601C118.878 46.2549 117.573 45.9955 116.256 45.9968C115.715 45.9983 115.175 46.0448 114.642 46.1359C113.49 43.9795 111.777 42.1766 109.685 40.919C107.593 39.6614 105.201 38.9961 102.762 38.9938H102.267C102.588 37.7207 102.754 36.4132 102.762 35.1C102.762 30.8295 101.071 26.7339 98.0618 23.7142C95.0522 20.6945 90.9704 18.998 86.7142 18.998C82.4581 18.998 78.3762 20.6945 75.3666 23.7142C72.3571 26.7339 70.6663 30.8295 70.6663 35.1C70.6741 36.4132 70.8403 37.7207 71.1613 38.9938H70.6663C67.1443 39.0895 63.7986 40.5605 61.3412 43.0938C58.8838 45.6271 57.5088 49.0227 57.5088 52.5578C57.5088 56.0929 58.8838 59.4885 61.3412 62.0218C63.7986 64.5551 67.1443 66.0261 70.6663 66.1218H117.563V66.0224C119.975 65.7086 122.19 64.5243 123.796 62.6907C125.401 60.8571 126.285 58.4998 126.285 56.0593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.99 35.06C203.99 33.0709 204.778 31.1634 206.18 29.7569C207.581 28.3504 209.483 27.5603 211.465 27.5603C211.867 27.5613 212.267 27.5978 212.663 27.6696C213.528 26.0552 214.814 24.7071 216.383 23.7693C217.952 22.8315 219.746 22.3393 221.573 22.3453H221.939C221.701 21.3934 221.578 20.4162 221.573 19.4348C221.527 17.8293 221.802 16.2309 222.383 14.7341C222.963 13.2372 223.837 11.8725 224.953 10.7205C226.068 9.5686 227.403 8.65288 228.877 8.02757C230.352 7.40226 231.936 7.08008 233.537 7.08008C235.138 7.08008 236.722 7.40226 238.197 8.02757C239.671 8.65288 241.006 9.5686 242.121 10.7205C243.237 11.8725 244.111 13.2372 244.691 14.7341C245.272 16.2309 245.547 17.8293 245.501 19.4348C245.497 20.417 245.371 21.3947 245.125 22.3453H245.501C248.174 22.3453 250.737 23.4107 252.627 25.3071C254.518 27.2035 255.579 29.7755 255.579 32.4574C255.579 35.1393 254.518 37.7114 252.627 39.6078C250.737 41.5042 248.174 42.5696 245.501 42.5696H210.445V42.5398C208.648 42.2915 207.002 41.3956 205.814 40.0194C204.626 38.6431 203.978 36.8804 203.99 35.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M163.588 220.526C228.724 220.526 281.527 215.052 281.527 208.298C281.527 201.545 228.724 196.07 163.588 196.07C98.4524 196.07 45.6494 201.545 45.6494 208.298C45.6494 215.052 98.4524 220.526 163.588 220.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.339 136.957C178.339 136.957 178.923 167.621 172.766 189.147",
    stroke: "#24285B",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.962 167.621H164.033V207.682H203.94L182.695 194.61L184.962 167.621Z",
    fill: "#FFBD59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.244 136.957C146.244 136.957 140.086 167.621 146.244 189.147",
    stroke: "#24285B",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.063 149.86C192.078 149.86 219.651 122.193 219.651 88.0648C219.651 53.9362 192.078 26.2695 158.063 26.2695C124.049 26.2695 96.4756 53.9362 96.4756 88.0648C96.4756 122.193 124.049 149.86 158.063 149.86Z",
    fill: "#FF6D34"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M195.268 38.9336C204.776 50.6755 209.66 65.5097 208.994 80.624C208.328 95.7382 202.158 110.082 191.654 120.936C181.15 131.79 167.042 138.4 152.005 139.513C136.967 140.625 122.046 136.163 110.068 126.973C115.543 133.774 122.393 139.333 130.167 143.282C137.941 147.23 146.462 149.479 155.166 149.878C163.87 150.278 172.56 148.821 180.661 145.601C188.762 142.382 196.09 137.475 202.161 131.204C208.232 124.933 212.907 117.44 215.879 109.222C218.85 101.003 220.05 92.2456 219.398 83.5275C218.747 74.8093 216.259 66.3291 212.099 58.6471C207.94 50.9651 202.203 44.2561 195.268 38.9634V38.9336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.77 90.1689C142.986 89.52 144.436 83.2213 143.009 76.1003C141.582 68.9794 137.818 63.7327 134.602 64.3817C131.386 65.0306 129.935 71.3293 131.362 78.4503C132.79 85.5712 136.554 90.8178 139.77 90.1689Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.34 82.9853C178.556 82.3364 180.007 76.0377 178.58 68.9167C177.152 61.7958 173.388 56.5491 170.172 57.1981C166.956 57.847 165.506 64.1457 166.933 71.2667C168.36 78.3876 172.124 83.6342 175.34 82.9853Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.576 119.563C194.576 119.563 187.933 95.7226 161.153 101.981C134.374 108.239 138.096 130.946 138.096 130.946",
    stroke: "#24285B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M128.227 102.145C133.051 101.172 136.546 98.3074 136.033 95.7473C135.52 93.1872 131.193 91.9009 126.369 92.8743C121.545 93.8476 118.05 96.7121 118.563 99.2722C119.076 101.832 123.403 103.119 128.227 102.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M191.77 89.321C196.594 88.3476 200.089 85.4831 199.576 82.923C199.063 80.3629 194.736 79.0766 189.912 80.05C185.088 81.0234 181.593 83.8879 182.106 86.448C182.619 89.0081 186.946 90.2944 191.77 89.321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.433 165.535L154.085 169.002L147.491 208.517L108.139 201.911L131.235 192.534L133.433 165.535Z",
    fill: "#FFBD59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.406 161.939C203.406 161.939 190.833 162.813 191.961 169.707C193.09 176.6 198.535 176.59 198.535 176.59C198.535 176.59 193.585 189.961 205.683 190.269C217.781 190.577 224.117 175.23 220.533 165.892C216.949 156.555 203.406 161.939 203.406 161.939Z",
    fill: "#FFBD59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.246 152.412C222.246 152.412 195.09 143.184 196.001 154.538C196.912 165.892 211.544 164.134 219.622 165.763C227.701 167.392 232.156 157.041 222.246 152.412Z",
    fill: "#FFBD59"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M222.246 152.412C222.246 152.412 195.09 143.184 196.001 154.538C196.912 165.892 211.544 164.134 219.622 165.763C227.701 167.392 232.156 157.041 222.246 152.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.779 193.875L236.72 207.166L248.907 207.215L250.708 193.945L234.779 193.875Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.958 70.0758C130.151 68.7429 132.029 66.9472 133.462 64.8135C134.894 62.6797 135.847 60.2589 136.254 57.7188",
    stroke: "#24285B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.004 52.0254C169.308 56.5965 174.086 59.8812 179.527 61.323",
    stroke: "#24285B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9219 95.7521C91.9219 95.7521 87.3481 68.0282 100.129 71.9121C108.237 74.3954 100.396 88.2624 103.099 95.7521C105.802 103.242 111.672 114.824 105.881 119.036C100.089 123.248 89.4667 122.582 91.9219 95.7521Z",
    fill: "#FFBD59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.738 193.914C242.738 193.914 242.461 187.656 248.273 187.228C254.084 186.801 259.311 196.526 254.846 202.357L250.292 194.073L242.738 193.914Z",
    fill: "#FF6D34"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M242.739 193.913C242.739 193.913 240.927 186.523 234.819 187.218C228.711 187.913 226.325 196.019 229.691 201.343L234.819 193.873L242.739 193.913Z",
    fill: "#FF6D34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4747_22018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306,
    height: 235,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContentPic);
export default __webpack_public_path__ + "static/media/noContentPic.ac11819fb9ef3f519db7496337fd38d3.svg";
export { ForwardRef as ReactComponent };